import Api from 'libs/api/index';

class FacilityCalendarApi extends Api {
  constructor() {
    super('facility/calendar/');
  }
}

export default FacilityCalendarApi;
